import Icon from '@tamagoshi/core/Icon';

export const flagLinks = [
  // TODO: Add france flag in Tamagoshi
  {
    value: 'fr',
    href: 'https://www.manomano.fr/',
    name: 'ManoMano FR',
    FlagId: Icon.FlagFrance,
    dataQa: 'contactFlagFRCta',
  },
  {
    value: 'it',
    FlagId: Icon.FlagItaly,
    href: 'https://www.manomano.it/',
    name: 'ManoMano IT',
    dataQa: 'contactFlagITCta',
  },
  {
    value: 'gb',
    FlagId: Icon.FlagUK,
    href: 'https://www.manomano.co.uk/',
    name: 'ManoMano UK',
    dataQa: 'contactFlagUKCta',
  },
  {
    value: 'de',
    FlagId: Icon.FlagGermany,
    href: 'https://www.manomano.de/',
    name: 'ManoMano DE',
    dataQa: 'contactFlagDECta',
  },
  {
    value: 'es',
    FlagId: Icon.FlagSpain,
    href: 'https://www.manomano.es/',
    name: 'ManoMano ES',
    dataQa: 'contactFlagESCta',
  },
];
